import { useSelect, dispatch } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { PanelRow, FormTokenField } from '@wordpress/components';

export default () => {

    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    let { wp_travel_enquiry_notif_emails, show_wp_travel_utilities, modules, options } = allData;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;

    const { updateSettings } = dispatch('WPTravel/Admin');

    const checkIfNotifEmailEmpty = () => {
        if ( '' == wp_travel_enquiry_notif_emails ) {
            wp_travel_enquiry_notif_emails = [];
        }
    }
    // if ( 'no' == show_wp_travel_utilities ) {
    //     return <p>{__('WP Travel Utilities is currently disabled please go to Addons Settings to enable it to use custom "To Email" and reload the page.')}</p>
    // }
    if ( ! isActive ) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return <>
        { checkIfNotifEmailEmpty() }
        <PanelRow>
            <label>{ _wp_travel.setting_strings.email_tempaltes.to_emails }</label>
            <div className="wp-travel-field-value">
                <FormTokenField 
                    label=""
                    value={ wp_travel_enquiry_notif_emails } 
                    suggestions={ [] } 
                    onChange={ tokens =>{
                        updateSettings({
                            ...allData,
                            wp_travel_enquiry_notif_emails: tokens
                        })
                    }}
                />
            </div>
        </PanelRow> 
    </>
}